export const ICONS_FOLDER_PATH = '/assets/svg/optimized/';
